<template>
  <div class="employee-certification">
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="姓名：" label-width="180px" label-position="right">
          <el-input v-model="formData.employee_name" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="工号：" label-width="180px" label-position="right">
          <el-input v-model="formData.employee_no" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="部门：" label-width="180px" label-position="right">
          <el-input v-model="formData.department_ids" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="职级类型：" label-width="180px" label-position="right">
          <el-input v-model="formData.level_type" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="当前职级：" label-width="180px" label-position="right">
          <el-input v-model="formData.current_level" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="当前称号：" label-width="180px" label-position="right">
          <el-input v-model="formData.current_title" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="下一职级：" label-width="180px" label-position="right">
          <el-input v-model="formData.next_level" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="下级称号：" label-width="180px" label-position="right">
          <el-input v-model="formData.next_title" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="开始从业日期：" label-width="180px" label-position="right">
          <el-input v-model="formData.start_work_date" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="从业年限：" label-width="180px" label-position="right">
          <el-input v-model="work_years" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="11">
        <el-form-item label="最低从业年限：" class="bold-label" label-width="180px" label-position="left">
          <el-input v-model="formData.min_year" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :offset="9" :span="4">
        <el-checkbox v-model="is_reach_year" disabled>达成</el-checkbox>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="晋升前置条件：" class="bold-label" label-width="180px" label-position="left">

        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :offset="2" :span="22">
        <el-table :data="promotionBeforeTable" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column label="晋升前置条件" align="center">
            <template #default="scope">
              完成{{ scope.row.short_name }}认证
            </template>
          </el-table-column>
          <el-table-column label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row.is_certified" disabled></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="考核前置条件：" class="bold-label" label-width="180px"
                      label-position="left">
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :offset="2" :span="22">
        <el-table :data="examTable" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column prop="condition" label="考核前置条件" align="center">
            <template #default="scope">
              {{ scope.row.exam_content }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row.is_passed"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="save-button">
        <el-button type="primary" @click="saveForm">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "EmployeeLevelEdit",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formData: {},
      work_years: 0,
      is_reach_year: false,
      promotionBeforeTable: [],
      certificationOptions: [],
      examTable: [],
      exam_ids: []
    };
  },
  methods: {
    async saveForm() {
      const param = {
        id: this.parentData.id,
        employee_no: this.parentData.employee_no,
        promotionData: this.promotionBeforeTable,
        examData: this.examTable,
        examIds: this.exam_ids,
        employee_name: this.employee_name,
        min_year : this.parentData.min_year
      }
      await this.$http("employeeLevelService.editEmployeeLevel", param).then(res=>{
        this.$message.success("保存成功！");
        this.$fn.closeWindow();
        this.$fn.search();
        this.$fn.refreshTabForm();
      })
    },
    headStyle() {
      return {
        'background-color': '#f0f0f0',
      }
    },
    async getData() {
      console.log(this.parentData)
      this.formData.employee_name = this.parentData.employee_name
      this.formData.employee_no = this.parentData.employee_no
      this.formData.department_ids = this.parentData.department_ids
      this.formData.level_type = this.parentData.level_type
      this.formData.current_level = this.parentData.current_level
      this.formData.current_title = this.parentData.current_title
      this.formData.next_level = this.parentData.next_level
      this.formData.next_title = this.parentData.next_title
      this.formData.start_work_date = this.parentData.start_work_date
      this.formData.work_year = this.parentData.work_year
      this.formData.min_year = this.parentData.min_year
      await this.$http("employeeLevelService.getEmployeeLevelData", this.formData).then(res => {
        this.promotionBeforeTable = res.certified_records
        this.examTable = res.exam_data
        this.exam_ids = res.exam_ids
        this.work_years = res.work_years
        this.is_reach_year = res.is_reach_year
      })
    },
  }
  ,
  mounted() {
    console.log(this.parentData)
    this.getData()
  }

}
</script>

<style scoped lang="less">
:deep .bold-label .el-form-item__label {
  font-weight: bold;
  color: black;
}

.employee-certification {
  padding: 20px;
}

.certification-section {
  margin-top: 20px;
}

.save-button {
  text-align: center;
  margin-top: 20px;
}
</style>